import { IconProps } from "../types"
import React from "react"

export const LogoSlack: React.FC<IconProps> = ({
  className,
  height = 48,
  width = 48,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.628 29.9063C10.628 32.2807 8.68838 34.2203 6.31401 34.2203C3.93963 34.2203 2 32.2807 2 29.9063C2 27.5319 3.93963 25.5923 6.31401 25.5923H10.628V29.9063Z"
      fill="#E01E5A"
    ></path>
    <path
      d="M13.7795 29.9063C13.7795 27.5319 15.7192 25.5923 18.0935 25.5923C20.4679 25.5923 22.4076 27.5319 22.4076 29.9063V41.6858C22.4076 44.0602 20.4679 45.9998 18.0935 45.9998C15.7192 45.9998 13.7795 44.0602 13.7795 41.6858V29.9063Z"
      fill="#E01E5A"
    ></path>
    <path
      d="M18.0935 10.628C15.7192 10.628 13.7795 8.68838 13.7795 6.31401C13.7795 3.93963 15.7192 2 18.0935 2C20.4679 2 22.4076 3.93963 22.4076 6.31401V10.628H18.0935Z"
      fill="#36C5F0"
    ></path>
    <path
      d="M18.0935 13.7798C20.4679 13.7798 22.4075 15.7194 22.4075 18.0938C22.4075 20.4682 20.4679 22.4078 18.0935 22.4078H6.31401C3.93963 22.4078 2 20.4682 2 18.0938C2 15.7194 3.93963 13.7798 6.31401 13.7798H18.0935Z"
      fill="#36C5F0"
    ></path>
    <path
      d="M37.372 18.0938C37.372 15.7194 39.3116 13.7798 41.686 13.7798C44.0604 13.7798 46 15.7194 46 18.0938C46 20.4682 44.0604 22.4078 41.686 22.4078H37.372V18.0938Z"
      fill="#2EB67D"
    ></path>
    <path
      d="M34.2205 18.0935C34.2205 20.4679 32.2808 22.4075 29.9065 22.4075C27.5321 22.4075 25.5925 20.4679 25.5925 18.0935V6.31401C25.5925 3.93963 27.5321 2 29.9065 2C32.2808 2 34.2205 3.93963 34.2205 6.31401V18.0935Z"
      fill="#2EB67D"
    ></path>
    <path
      d="M29.9065 37.3721C32.2808 37.3721 34.2205 39.3117 34.2205 41.6861C34.2205 44.0604 32.2808 46.0001 29.9065 46.0001C27.5321 46.0001 25.5925 44.0604 25.5925 41.6861V37.3721H29.9065Z"
      fill="#ECB22E"
    ></path>
    <path
      d="M29.9065 34.2208C27.5321 34.2208 25.5925 32.2812 25.5925 29.9068C25.5925 27.5324 27.5321 25.5928 29.9065 25.5928H41.686C44.0604 25.5928 46 27.5324 46 29.9068C46 32.2812 44.0604 34.2208 41.686 34.2208H29.9065Z"
      fill="#ECB22E"
    ></path>
  </svg>
)
